import {
  GSTREGISTER_REPORT_REQUEST,
  GSTREGISTER_REPORT_SUCCESS,
  GSTREGISTER_REPORT_FAILURE,
} from "../types/gst-register-report-types";

const initialState = {
  gstRegisterReport: {},
  loading: false,
  error: null,
};

const gstRegisterReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GSTREGISTER_REPORT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GSTREGISTER_REPORT_SUCCESS: {
      return {
        ...state,
        gstr2Report: {...(action.payload || {})},
        loading: false,
        error: null
      };
    }
    case GSTREGISTER_REPORT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    default:
      return state;
  }
};

export default gstRegisterReportReducer;
